// extracted by mini-css-extract-plugin
module.exports = {"customPagingButton":"SportlightCarousel_customPagingButton__1pN_5"};